var ErrorReasons = require('client/errors');

function ErrorType(reason) {
    this.reason = reason;
    this.id = reason.id;
    
    this.asCommandError = function() {
        return new CommandError(this); 
    };
}

function CommandError(type, message) {
    this.type = type;
    this.message = message || type.reason.reason;
}

CommandError.prototype.toString = function() {
    return this.message; 
};

CommandError.ErrorType = {
    COMMUNICATION_FAILURE               : new ErrorType(ErrorReasons.COMMUNICATION_FAILURE),
    ACCESS_DENIED                       : new ErrorType(ErrorReasons.ACCESS_DENIED),
    TOPIC_TREE_REGISTATION_CONFLICT     : new ErrorType(ErrorReasons.TOPIC_TREE_REGISTRATION_CONFLICT)
};

module.exports = CommandError;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/command-error.js
// module id = 200
// module chunks = 1